import { getToken, recoverFromAuthFailure } from '@coverright/shared/keycloak';
import { InMemoryCacheConfig } from '@apollo/client';
import { environment } from '@coverright/shared/config';
import { getApolloClient } from './get-apollo-client';

const inMemoryCacheConfig: InMemoryCacheConfig = {
  typePolicies: {
    MedigapPlanOutput: {
      keyFields: ['key'],
    },
    DrugOutput: {
      keyFields: ['rxcui', 'packRxcui'],
      fields: {
        quantity: (existing) => {
          if (typeof existing === 'number') {
            return existing.toFixed(2)
          }
          return existing;
        }
      }
    },
    PharmacyLocationDistanceOutput: {
      keyFields: ['npi'],
    },
    PdpPlan: {
      keyFields: ['bidId', 'planYear'],
    },
    ProviderOutput: {
      keyFields: ['npi'],
    },
    Plan: {
      keyFields: ['bidId', 'planYear'],
      fields: {
        prescriptionDrugDeductible: (existing, { readField }) => {
          const drugDetails: any = readField('drugDetails');
          const SNPType: any = readField('SNPType');
          if (
            !drugDetails ||
            (!drugDetails.mrxAltDedAmount && !drugDetails.mrxAltNoDedTier)
          ) {
            return ['No deductible'];
          }
          if (drugDetails.mrxAltDedAmount === '$0' && SNPType === 'D_SNP') {
            return [drugDetails.mrxAltDedAmount];
          }
          return [
            drugDetails.mrxAltDedAmount || '',
            drugDetails.mrxAltNoDedTier || '',
          ];
        },
        prescriptionDrugDeductibleShort: (existing, { readField }) => {
          const drugDetails: any = readField('drugDetails');
          const SNPType: any = readField('SNPType');
          if (
            !drugDetails ||
            (!drugDetails.mrxAltDedAmountShort && !drugDetails.mrxAltNoDedTier)
          ) {
            return ['No deductible'];
          }
          if (drugDetails.mrxAltDedAmountShort === '$0' && SNPType === 'D_SNP') {
            return [drugDetails.mrxAltDedAmountShort];
          }
          return [
            drugDetails.mrxAltDedAmountShort || '',
            drugDetails.mrxAltNoDedTier || '',
          ];
        },
      },
    },
    Query: {
      fields: {
        PdpPlans: {
          keyArgs: ['filter', 'sort'],
          merge(existing, incoming, { args }) {
            const page = args?.page || { page: 0, size: 8 };
            const offset = page.size * page.page;

            const merged = existing?.data ? existing.data.slice(0) : [];
            for (let i = 0; i < incoming.data.length; i++) {
              merged[offset + i] = incoming.data[i];
            }
            return {
              ...incoming,
              data: merged,
            };
          },
        },
        plans: {
          keyArgs: ['filter', 'sort'],
          merge(existing, incoming, { args }) {
            const page = args?.page || { page: 0, size: 8 };
            const offset = page.size * page.page;

            const merged = existing?.data ? existing.data.slice(0) : [];
            for (let i = 0; i < incoming.data.length; i++) {
              merged[offset + i] = incoming.data[i];
            }
            return {
              ...incoming,
              data: merged,
            };
          },
        },
      },
    },
  },
};

const { client: mainBackendApolloClient, cache: mainBackendApolloCache, preloadQuery } = getApolloClient(
  getToken,
  environment.graphqlUrl,
  inMemoryCacheConfig,
  false,
  recoverFromAuthFailure
);

export { mainBackendApolloClient, mainBackendApolloCache, preloadQuery };
